import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { GlobalVariable } from '../global';

@Component({
  selector: 'app-supercategories',
  templateUrl: './supercategories.page.html',
  styleUrls: ['./supercategories.page.scss'],
})
export class SupercategoriesPage implements OnInit {

  constructor(
    public globals:GlobalVariable,
    public  popoverController: PopoverController
  ) { }

  ngOnInit() {
  }
  getDataFromPopover(superCat){
    this.popoverController.dismiss(superCat);
  }
}
